import { createReducer } from "@reduxjs/toolkit";
import type { ProcessingState } from "@redux/state/shared-types";
import { resetUpdateFundingRequestError, updateFundingRequestError } from "./update-funding-request-error";

const initialState: ProcessingState = { processing: "idle" };

export const updateFundingRequestErrorReducer = createReducer<ProcessingState>(initialState, builder => {
  builder.addCase(updateFundingRequestError.fulfilled, state => {
    return {
      ...state,
      processing: "success",
    };
  });
  builder.addCase(updateFundingRequestError.pending, state => {
    return {
      ...state,
      processing: "pending",
    };
  });
  builder.addCase(updateFundingRequestError.rejected, state => {
    return {
      ...state,
      processing: "failed",
    };
  });
  builder.addCase(resetUpdateFundingRequestError, () => {
    return initialState;
  });
});
